import { render } from "./BlockUsers.vue?vue&type=template&id=4494d245&scoped=true"
import script from "./BlockUsers.vue?vue&type=script&lang=js"
export * from "./BlockUsers.vue?vue&type=script&lang=js"

import "./BlockUsers.vue?vue&type=style&index=0&id=4494d245&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4494d245"]])

export default __exports__